class PressFilters extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    this.selectMonthElement = this.querySelector('.select-month__container');
    this.selectYearElement = this.querySelector('.select-year__container');
    this.storedMonthValues = [];
    this.storedYearValues = [];

    window.addEventListener('click', (event) => {
      if (!event.target.closest('.press-filter-parent__element')) {
        this.hideDropdown();
      }
    });

    this.selectMonthElement?.addEventListener('click', (event) => {
      this.showDropdown(event);
    });

    this.selectYearElement?.addEventListener('click', (event) => {
      this.showDropdown(event);
    });

    this.searchInput = this.querySelector('.press-search__input');
    this.searchInput?.addEventListener("keyup", () => { 
      this.showFilterResults();
      this.searchResults();
    });

    this.filterInputs = this.querySelectorAll('.press-input');
    this.filterInputs?.forEach((eachInput) => {
      eachInput.addEventListener('change', (event) => {
        this.hideDropdown();
        const filterValue = event.target.value;    
        const isMonthInput = event.target.closest('.press-filter-month-container');
        const isYearInput = event.target.closest('.press-filter-year-container');

        if (event.target.checked) {
          // Add the value to the appropriate array
          if (isMonthInput && !this.storedMonthValues.includes(filterValue)) {
            this.storedMonthValues.push(filterValue);
          } else if (isYearInput && !this.storedYearValues.includes(filterValue)) {
            this.storedYearValues.push(filterValue);
          }
        } else {
          // Remove the value from the appropriate array
          if (isMonthInput) {
            this.storedMonthValues = this.storedMonthValues.filter(value => value !== filterValue);
          } else if (isYearInput) {
            this.storedYearValues = this.storedYearValues.filter(value => value !== filterValue);
          }
        }

        this.showFilterResults();
        this.searchResults();
      });
    })
  }

  showDropdown(event) {
    this.dropdownList = event.target.closest('.press-filter-parent__element');
    this.hideDropdown();
    this.dropdownList.classList.add('dropdown-visible')
  }

  hideDropdown() {
    this.dropdowns = this.querySelectorAll('.press-filter-parent__element');
    this.dropdowns.forEach((dropdown) => {
      dropdown.classList.remove('dropdown-visible');
    });
  }

  searchResults() {
    this.press_search_list = [];
    let searchQuery = this.searchInput.value.toLowerCase() 

    let pressContent = document.querySelectorAll(".press-grid__wrapper .press-item__content");
    if (this.storedMonthValues.length > 0 || this.storedYearValues.length > 0) {
      pressContent = document.querySelectorAll(".press-grid__wrapper .is-active .press-item__content");    
    }

    if (searchQuery.length > 0) {
      for (let i = 0; i < pressContent.length; i++) {
      const currentSearchName = pressContent[i].textContent.toLowerCase();
    
      // Search and Display the content
      if (currentSearchName.includes(searchQuery)) {
        pressContent[i].closest('.press-item-content').classList.add('is-active');
      } else {
        pressContent[i].closest('.press-item-content').classList.remove('is-active');
      }
    
        // To Show the press no results found
        let obj = {};
        obj.press_title = currentSearchName;
        this.press_search_list.push(obj);
    
        var filteredList = this.press_search_list.filter(function (arr) {
          return arr.press_title.includes(searchQuery);
        });
      }
    } else {
      if (this.storedMonthValues.length > 0) {
        pressContent.forEach((eachProduct) => eachProduct.closest('.press-item-content').classList.add('is-active'));
      }
    }
  }

  showFilterResults() {
    let pressContentEle = document.querySelectorAll(".press-grid__wrapper .press-item__date-wrapper");
    if (this.storedYearValues.length > 0 && this.storedMonthValues.length <= 0) {
      pressContentEle?.forEach((eachProduct) => {
        const filterName = eachProduct.textContent.toLowerCase();
  
        // Check if the product type matches any of the selected filter values
        const matches = this.storedYearValues.some(value => filterName.includes(value.toLowerCase()));
        if (matches) {
          eachProduct.closest('.press-item-content').classList.add('is-active');
        } else {
          eachProduct.closest('.press-item-content').classList.remove('is-active');
        }
      });
    } else if (this.storedMonthValues.length > 0 && this.storedYearValues.length <= 0) {
      pressContentEle?.forEach((eachProduct) => {
        const filterName = eachProduct.textContent.toLowerCase();
  
        // Check if the product type matches any of the selected filter values
        const matches = this.storedMonthValues.some(value => filterName.includes(value.toLowerCase()));
        if (matches) {
          eachProduct.closest('.press-item-content').classList.add('is-active');
        } else {
          eachProduct.closest('.press-item-content').classList.remove('is-active');
        }
      });
    }
    else if(this.storedYearValues.length > 0 && this.storedMonthValues.length > 0) {
      pressContentEle?.forEach((eachProduct) => {
        const filterText = eachProduct.textContent.toLowerCase();
  
        // Check if the product type matches any of the selected filter values
        const matchesMonth = this.storedMonthValues.some(value => filterText.includes(value.toLowerCase()));
        const matchesYear = this.storedYearValues.some(value => filterText.includes(value.toLowerCase()));

        if (matchesMonth && matchesYear) {
          eachProduct.closest('.press-item-content').classList.add('is-active');
        } else {
          eachProduct.closest('.press-item-content').classList.remove('is-active');
        }
      });

    }else {
      let searchQuery = this.searchInput.value.toLowerCase() 
      if (searchQuery.length <= 0 || this.storedMonthValues <= 0 || this.storedYearValues <= 0) {
        document.querySelectorAll(".press-grid__wrapper .press-item__date-wrapper").forEach((eachProduct) => eachProduct.closest('.press-item-content').classList.add('is-active'));
      }
    }

  }

}
customElements.define('press-filters', PressFilters);
